/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <div class="recommendwrap">
    <ul class="recommend clearfix">
      <li
        :class="{ active: index == chooseIndex }"
        v-for="(item, index) in navlist"
        @click="chooseSee(index)"
        :key="index"
      >
        <p>{{ item }}</p>
        <span></span>
      </li>
    </ul>
    <ol v-for="(items, aindex) in navlists" :key="aindex">
      <template v-if="aindex == chooseIndex">
        <li
          v-for="(item, index) in items"
          :key="index"
          @mouseenter="choosebook(index)"
          @mouseleaver="choosebook(index)"
        >
          <a class="nochoose clearfix" v-show="hoverIndex !== index">
            <span class="fl ellipsis" style="display:inlineblock;width:60%"
              ><span>{{ index + 1 }}</span> {{ item.name }}</span
            >
            <span
              class="fr ellipsis"
              style="display:inlineblock;width:40%"
              v-if="item.author != undefined"
              >{{ item.author.name }}</span
            >
          </a>
          <div v-show="hoverIndex == index" class="choosed clearfix">
            <a href="ja:" class="clearfix" @click="goSeeDetail(item.id)">
              <img class="fl" v-lazy="imgURL + item.iconUrl" alt="" />
              <div class="fl" style="width:129px">
                <p class="bookname ellipsis">{{ item.name }}</p>
                <p class="aname clearfix" v-if="item.author != undefined">
                  <span class="ellipsis fl" style="display:block;width:60%">
                    {{ item.author.name }}</span
                  >
                  <span class="fl" style="margin:0 3px">|</span
                  ><span class="fl">{{ item.sort }}</span>
                </p>
              </div>
            </a>
          </div>
        </li>
      </template>
    </ol>
  </div>
</template>

<script>
export default {
  props: {
    navlist: Array,
    navlists: Array
  },
  data() {
    return {
      chooseIndex: 0,
      hoverIndex: 0
    };
  },
  methods: {
    chooseSee(index) {
      this.chooseIndex = index;
      this.hoverIndex = 0;
    },
    choosebook(index) {
      this.hoverIndex = index;
    },
    goSeeDetail(bookid) {
      const news = this.$router.resolve(`/bookdetail/${bookid}`);
      window.open(news.href, "_blank");
    }
  }
};
</script>

<style lang="stylus" scoped>
.recommendwrap
    width 205px
    .recommend
        border-bottom 1px solid #ededed
        margin-bottom 18px
        li
            height 32px
            position relative
            float left
            margin-right 14px
            cursor pointer
            &.active
                span
                    background rgba(72, 162, 223, 1)
                p
                    font-size 16px
                    color #48A2DF
            p
                height 22px
                margin-bottom 9px
                color #818181
                font-size 14px
                transition all 0.17s ease-in-out
            span
                width 20px
                height 3px
                background #fff
                border-radius 2px
                position absolute
                bottom 0
                left 0
                right 0
                margin 0 auto
                transition all 0.17s ease-in-out
    ol
        font-size 12px
        color #666666
        li
            margin-bottom 10px
            cursor pointer
            span
                span
                    width 15px
                    display inline-block
            .choosed
                img
                    width 54px
                    height 75px
                    background rgba(247, 247, 247, 1)
                    box-shadow 0px 0px 6px 0px rgba(160, 160, 160, 0.5)
                    margin-right 14px
                div
                    .bookname
                        font-weight 600
                        color rgba(51, 51, 51, 1)
                        margin-bottom 10px
                    .aname
                        font-size 12px
                        font-weight 600
                        color rgba(129, 129, 129, 1)
</style>
